import { render, staticRenderFns } from "./LoadingScreenComponent.vue?vue&type=template&id=74fa5246"
import script from "./LoadingScreenComponent.vue?vue&type=script&lang=js"
export * from "./LoadingScreenComponent.vue?vue&type=script&lang=js"
import style0 from "./LoadingScreenComponent.vue?vue&type=style&index=0&id=74fa5246&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports